import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Spin, message, Progress } from "antd";
import axios from "axios";


const { Meta } = Card;

const Activities = () => {
  const [activities, setActivities] = useState([]);
  const [stories, setStories] = useState([]);
  const [tasksByActivity, setTasksByActivity] = useState({});
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [activitiesRes, storiesRes] = await Promise.all([
          axios.get("/api/activities/user"),
          axios.get("/api/stories"),
        ]);

        const sortedActivities = activitiesRes.data.sort((a, b) => b.id - a.id);
        setActivities(sortedActivities);
        setStories(storiesRes.data);

        // Fetch tasks for all activities
        const tasksPromises = sortedActivities.map((activity) =>
          axios.get(`/api/activities/${activity.id}/tasks`)
        );
        const tasksRes = await Promise.all(tasksPromises);

        const tasksMap = {};
        sortedActivities.forEach((activity, index) => {
          tasksMap[activity.id] = tasksRes[index].data;
        });
        setTasksByActivity(tasksMap);
      } catch (error) {
        console.error("Fehler beim Laden:", error);
        message.error(
          "Fehler beim Laden der Aktivitäten, Geschichten oder Aufgaben."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <Spin size="large" className="loader" />;
  }

  return (
    <Row gutter={[16, 16]}>
      {activities.map((activity) => {
        const story = stories.find((s) => s.id === activity.story_id);
        const imageUrl = story?.img
          ? `/api/stories/imagefile/${story.img}`
          : null;

        // Calculate progress
        const tasks = tasksByActivity[activity.id] || [];
        const completedCount = tasks.filter(
          (t) => t.status === "completed"
        ).length;
        const totalCount = tasks.length;
        const progressPercent =
          totalCount === 0
            ? 0
            : Math.round((completedCount / totalCount) * 100);
            

            const statusClass =
  progressPercent === 100
    ? "completed"
    : progressPercent > 0
    ? "in-progress"
    : "not-started";

        return (
          <Col xs={24} sm={12} md={8} lg={6} key={activity.id}>
            <Card
              hoverable
              onClick={() => navigate(`/activities/${activity.id}`)}
              className={`activity-card ${statusClass}`}
              cover={
                imageUrl ? (
                  <img
                    alt={story.title}
                    src={imageUrl}
                    style={{
                      height: 150,
                      marginTop: 15,
                      objectFit: "contain",
                      borderTopLeftRadius: 6,
                      borderTopRightRadius: 6,
                    }}
                  />
                ) : null
              }
            >
              <div style={{ flexGrow: 1, paddingTop: 8 }}>
                <Meta
                  title={activity.title}
                  description={
                    story?.title ? `Geschichte: ${story.title}` : null
                  }
                />

                {/* Progress Bar */}
                <div style={{ marginTop: 16 }}>
                  <Progress
                    percent={progressPercent}
                    strokeWidth={16}
                    showInfo
                    status={progressPercent === 100 ? "success" : "active"}
                    className={`task-progress is-small ${
                      progressPercent === 100 ? "is-complete"  : progressPercent > 0
                      ? "is-active"
                      : "is-not-started"
                    }`}
                  />
                </div>
              </div>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default Activities;
